export enum PneEmrWidgets {
  FB_EMR_INSURANCE_INFO = 'fb-emr-insurance-info',
  FB_EMR_MEDICAL_HISTORY = 'fb-emr-medical-history',
  FB_EMR_DEMOGRAPHICS = 'fb-emr-demographics',
  FB_EMR_MEDICAL_NOTES = 'fb-emr-medical-notes',
  FB_EMR_SHOTS = 'fb-emr-shots',
  FB_EMR_LASER = 'fb-emr-laser',
  FB_EMR_SOAP_NOTES = 'fb-emr-soap-notes',
  FB_EMR_EQUIPMENT = 'fb-emr-equipment',
  FB_EMR_VITALS = 'fb-emr-vitals',
}
export class InsurancePayer {
  InsurancePayerId?: string;
  Name: string;
  PayerId: string | number;
}
export enum InsuranceType {
  PRIMARY_INSURANCE = 'primary-insurance',
  SECONDARY_INSURANCE = 'secondary-insurance',
  TERTIARY_INSURANCE = 'tertiary-insurance',
}

export interface PneAppointment {
  AppointmentId: string | number;
  CompanyId: string | number;
  Location_ID?: string | number;
  LocationId?: string | number;
  CustomerId: string | number;
  PetId: string;
  EmployeeId: string | number;
  ServiceId: string | number;
  TreatmentId: string | number;
  ServiceTypeId: string | number | null;
  ResourceId1: string;
  ResourceId2: string;
  ResourceTypeId1: string | number | null;
  ResourceTypeId2: string | number | null;
  Customer: string;
  Employee: string;
  Service: string;
  PetName: string;
  ApptType: string;
  StartDate: string;
  Init: number;
  Delay: number;
  Complete: number;
  Notes: string;
  BookedOnline: boolean;
  IsNoShow: boolean;
}

export function getPneLocationRemoteId(
  appointment: Partial<PneAppointment> | null | undefined,
): string | number | null {
  const locationId =
    appointment?.Location_ID ?? appointment?.LocationId ?? (appointment as any)?.location_remote_id;

  if (locationId === undefined) {
    return null;
  }

  if (locationId === null) {
    return null;
  }

  if (locationId === '') {
    return null;
  }

  return locationId;
}
